import React, { useState } from 'react';
import { useLocation } from 'react-router-dom';
import FilterImg from '../assets/images/filter.svg';

const SubHeader = ({ title, setDateRange }) => {
  const location = useLocation();
  const isSchedulesPage = location.pathname.includes('schedules');
  const isDetailImagesPage = location.pathname === '/detail-images';
  const isProfil = location.pathname === '/profil';
  const isPDF = location.pathname === '/pdf-viewer';
  const isRequestService = location.pathname.includes('/request');
  const [isDropdownVisible, setDropdownVisible] = useState(false);

  const handleDropdownClick = (event) => {
    const value = event.target.getAttribute('data-val');
    setDateRange(parseInt(value)); // Notify parent of the selected range
    setDropdownVisible(false);
  };

  const handleResetClick = () => {
    setDateRange(null);
    setDropdownVisible(false);
  };

  const dateRangeText = isSchedulesPage ? 'Next' : 'Previous'; // Conditional text

  return (
    <div className="subheading_wrap">
      <div>
        <h3 className="subheading_title">{title}</h3>
      </div>
      {!isDetailImagesPage && !isPDF && !isRequestService && !isProfil && (
        <div className="filter-subheading">
          <img
            src={FilterImg}
            alt="Filter"
            onClick={() => setDropdownVisible(!isDropdownVisible)}
          />
          {isDropdownVisible && (
            <div className="dropdown-menu">
              {/* Dynamically change the text (Next / Previous) */}
              <div data-val="7" className="dropdown-item" onClick={handleDropdownClick}>{dateRangeText} 7 Days</div>
              <div data-val="14" className="dropdown-item" onClick={handleDropdownClick}>{dateRangeText} 14 Days</div>
              <div data-val="30" className="dropdown-item" onClick={handleDropdownClick}>{dateRangeText} 30 Days</div>
              <div data-val="90" className="dropdown-item" onClick={handleDropdownClick}>{dateRangeText} 90 Days</div>
              <div data-val="null" className="dropdown-item reset-item" onClick={handleResetClick}>
                Reset
              </div>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default SubHeader;
